<template>
  <div class="t-filter__item" :class="{ _active: openSearch }" :style="{ width: styleOpenSearch }">
    <div v-if="!isLk" class="t-filter__name">{{ $root.staticText.search }}</div>
    <form class="t-filter__selected" @submit.prevent="submitSearch">
      <!--            <svg v-if="isMobile" @click.stop="closeSearchMobileFun" class="t-vendors__search-delete" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
      <!--                <path opacity="0.16" d="M4.44531 4.44434L11.7786 11.7777M11.7786 4.44434L4.44531 11.7777" stroke="#1E2849" stroke-linecap="round" stroke-linejoin="round"/>-->
      <!--            </svg>-->
      <input
        class="t-vendors__search"
        type="text"
        :placeholder="$root.staticText.forms.placeholderCompany2"
        v-model="search"
        @focus="openSearch = searchResults.length > 0"
        @focusout="openSearch = false"
        @input="searchItems"
      />
      <svg
        class="t-vendors__search-svg"
        @click="submitSearch"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.87875 5.62679C8.01613 5.62679 7.18884 5.96945 6.57888 6.57938C5.96892 7.18932 5.62625 8.01656 5.62625 8.87914C5.62625 9.74171 5.96892 10.569 6.57888 11.1789C7.18884 11.7888 8.01613 12.1315 8.87875 12.1315C9.74136 12.1315 10.5686 11.7888 11.1786 11.1789C11.7886 10.569 12.1312 9.74171 12.1312 8.87914C12.1312 8.01656 11.7886 7.18932 11.1786 6.57938C10.5686 5.96945 9.74136 5.62679 8.87875 5.62679ZM4 8.87914C3.9999 8.11134 4.18104 7.35437 4.52867 6.66977C4.8763 5.98518 5.38062 5.3923 6.00061 4.93935C6.62059 4.4864 7.33874 4.18618 8.09664 4.06309C8.85454 3.94001 9.63079 3.99754 10.3623 4.23101C11.0937 4.46448 11.7598 4.86729 12.3062 5.40669C12.8526 5.94608 13.264 6.60683 13.5069 7.33519C13.7498 8.06356 13.8174 8.83896 13.7041 9.59835C13.5908 10.3577 13.2999 11.0797 12.8549 11.7054L16.7717 15.6221C16.9199 15.7754 17.0018 15.9808 17 16.194C16.9981 16.4072 16.9126 16.6111 16.7618 16.7619C16.6111 16.9126 16.4071 16.9981 16.1939 17C15.9807 17.0018 15.7753 16.9199 15.622 16.7718L11.706 12.8559C10.9761 13.3749 10.1174 13.683 9.22406 13.7464C8.3307 13.8097 7.43714 13.626 6.64127 13.2153C5.84541 12.8046 5.17796 12.1827 4.71207 11.4179C4.24618 10.653 3.99983 9.7747 4 8.87914Z"
          fill="#C8C8C8"
        />
      </svg>
    </form>
    <transition name="fade">
      <div v-if="openSearch" class="t-filter-list">
        <div class="t-filter-list__container">
          <router-link
            :to="{
              name: $route.name,
              query: Object.assign(
                {},
                $route.query,
                { [formName ? `${formName}[q]` : 'q']: item.text },
                {
                  [formName ? `${formName}[loadMore]` : 'loadMore']: undefined,
                  [formName ? `${formName}[currentPage]` : 'currentPage']: undefined,
                }
              ),
            }"
            :key="'search-item' + index"
            v-for="(item, index) in searchResults"
            class="t-vendors__search-item"
            v-text="item.text"
          >
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  name: 'filter-search',
  props: {
    isLk: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: 'searchItems',
    },
    formName: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      openSearch: false,
      openSearchMobile: false,
      search: '',
      searchResults: [],
      styleOpenSearch: null,
      timeOut: null,
    }
  },
  watch: {
    $route: function() {
      this.search = this.formName ? this.$route.query[`${this.formName}[q]`] : this.$route.query.q
    },
  },
  computed: {
    ...mapState('mobile', ['isMobile']),
  },
  methods: {
    submitSearch() {
      if ((this.formName ? this.$route.query[`${this.formName}[q]`] : this.$route.query.q) !== this.search) {
        this.openSearch = false

        if (this.search === '') {
          this.routerPush(undefined)
        } else {
          this.routerPush(this.search)
        }
      }
    },
    routerPush(search) {
      this.$router.push({
        name: this.$route.name,
        query: Object.assign({}, this.$route.query, {
          [this.formName ? `${this.formName}[q]` : 'q']: search,
          [this.formName ? `${this.formName}[loadMore]` : 'loadMore']: undefined,
          [this.formName ? `${this.formName}[currentPage]` : 'currentPage']: undefined,
        }),
      })
    },
    searchItems() {
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        if (this.search) {
          let url = process.env.NODE_ENV !== 'production' ? 'searchItems/index.json' : this.action
          let method = process.env.NODE_ENV !== 'production' ? 'get' : 'post'

          Vue.http[method](url, { search: this.search })
            .then(response => response.json())
            .then(data => {
              this.searchResults = data.items
              this.openSearch = this.searchResults.length > 0
            })
        }
      }, 800)
    },
  },
  mounted() {
    this.search = this.formName ? this.$route.query[`${this.formName}[q]`] : this.$route.query.q
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/ui-components/filter-search/filter-search.vue